import { useState, useEffect, useCallback } from 'react';
import { getUserTimezone, setUserTimezone as persistUserTimezone } from '../utils/userTimezone';

/**
 * Subscribe to commray time zone preference; re-renders when it changes (any settings menu).
 */
export function useUserTimezone() {
  const [timezone, setTimezoneState] = useState(getUserTimezone);
  useEffect(() => {
    const onChange = () => setTimezoneState(getUserTimezone());
    window.addEventListener('commray-timezone-change', onChange);
    return () => window.removeEventListener('commray-timezone-change', onChange);
  }, []);
  const setTimezone = useCallback((tz) => {
    persistUserTimezone(tz);
    setTimezoneState(getUserTimezone());
  }, []);
  return { timezone, setTimezone };
}
